export default __webpack_public_path__ + "static/media/logo_blanco.a775bbc1.png";